<template>
  <div class="container">
    <!-- <div class="helpinfo">

    </div> -->
    <div id="footer" class="footer">
      <!-- <div class="wrap-lg">
        <span>© 2022 CQC</span
        ><a rel="nofollow" target="_blank" href="http://beian.miit.gov.cn/"
          >ICP备18022763号-3</a
        >
      </div> -->
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {

    }
  }
}
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
}
.helpinfo {
  width: 100%;
  max-width: 1226px;
  padding: 61px 0 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #282828;
  background: #111111;
  margin: 0 auto;
  line-height: 1;
  min-height: 200px;
}
.footer {
  width: 100%;
  max-width: 1226px;
  padding: 10px 0 10px 0;
}
</style>